var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"scroll":_vm.handleScroll}},[_c('div',{ref:"content",staticClass:"scrollBox"},[_vm._t("default")],2),_c('div',{staticClass:"scorll-box",style:({
      '--scrollwidth': _vm.scrollwidth + 'rem',
      '--scrollHeight': _vm.scrollHeight + 'rem',
      '--scrollColor': _vm.scrollColor,
    })},[_c('div',{staticClass:"scorll-block",style:({
        '--blockwidth': _vm.blockwidth + 'rem',
        '--blockColor': _vm.blockColor,
        '--box-left': this.scroll + 'px',
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }